import React from 'react'
import {
  Button as BootstrapButton
} from 'react-bootstrap'
import classes from './Button.module.scss'

interface Props {
  icon?: React.ReactElement
  bsStyle?: string
  [key: string]: any
}

export class Button extends React.Component<Props, {}> {
  render () {
    const {
      children,
      icon,
      bsStyle,
      ...restProps
    } = this.props

    let iconClassName = classes.icon
    if (bsStyle) iconClassName += ' ' + classes.styled
    if (React.Children.count(children) > 0) iconClassName += ' ' + classes.margin
  
    return (
      <BootstrapButton
        {...restProps}
        bsStyle={bsStyle}
      >
        {icon &&
          React.cloneElement(icon, {
            className: icon.props.className ? icon.props.className + ' ' + iconClassName : iconClassName
          })
        }
        {children}
      </BootstrapButton>
    )
  }
}

export default Button

